import { lOGIN_BANNER } from "./ColumnConstants";
// import  lOGIN_BANNER_IMAGE_2  from "../assets/Hayosha/grameseva_banner.jpg";
// import  lOGIN_BANNER_IMAGE_3  from "../assets/Hayosha/grameseva_banner_2.jpg";
import  lOGIN_BANNER_IMAGE_2  from "../assets/Hayosha/grameseva_banner_1_cropped.jpg";
import  lOGIN_BANNER_IMAGE_3  from "../assets/Hayosha/grameseva_banner_2 Cropped.jpg";
import  login_image_new  from "../assets/Hayosha/login1_image_cropped.jpg";
import  login_imag_4  from "../assets/Hayosha/login-image-new.jpeg";
export const AUTH_TOKEN = "auth_token";
export const USER_DATA_TOKEN = "user_data_token";
export const USER_DATA = "user_data";

// const login_image_new = "../assets/Hayosha/login1_image_cropped.jpg";
// object-position: center center; /* You can adjust like 'top center', 'left center', etc. */
// .carousel-image {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     object-position: center center; /* You can adjust like 'top center', 'left center', etc. */
//   }
  

export const Login_CAROUSEL_DATA =[
    {
        src:lOGIN_BANNER_IMAGE_3,
        alt:"grameseva_banner_2",
        id:2,
        // position:"-400px center"
        position:"center center"

    },
    {
        src:login_image_new,
        alt:"banner img",
        id:1,
        position:"center center"
    },
    {
        src:lOGIN_BANNER_IMAGE_2,
        alt:"grameseva_banner",
        id:3,
        // position:"-1100px center"
        position:"center center"

    },
    {
        src:login_imag_4,
        alt:"grameseva_banner-new",
        id:4,
        // position:"-1100px center"
        position:"center center",
        objectFitClass:"fill"

    }
];